// import { Link } from "react-router-dom";

import {useLocation, useNavigate, useParams} from "react-router-dom";
import {MinusIcon, ArrowLeft, PlusIcon, X} from "lucide-react";
import {FC, useEffect, useState} from "react";
import { formatWithThousandsSeparator } from "../utils/currency.ts";
import { submitPayment } from "../api/payment.ts";
import paymentStore from "../store/paymentStore.ts";
import PhoneNumberInput from "../components/PhoneNumberInput.tsx";
import {
  createVoucherWithThirds,
  createVoucherWithThirdsParams,
} from "../api/events.ts";
import useDataStore from "../store/dataStore.ts";
import Error from "../assets/error.tsx";

interface QuantityButtonProps {
  type: 'plus' | 'minus';
  disable: boolean;
  onPress: () => void;
}

const QuantityButton: FC<QuantityButtonProps>  = ({ type, disable, onPress }) => {
  return (
      <button onClick={onPress} className={`${disable ? 'border-[#C8C8C8]': 'border-primary'} size-14 rounded-full border-2 flex items-center justify-center`}>
       {/* <p className={`${disable ? 'text-[#C8C8C8]' : 'text-[#9EBE43]'} text-4xl`}>{type === 'minus' ? '-' : '+'}</p>*/}
        {type === 'minus' ? <MinusIcon size={20} className={`${disable ? 'text-[#C8C8C8]' : 'text-primary'} text-4xl`}/> : <PlusIcon className={`${disable ? 'text-[#C8C8C8]' : 'text-primary'} text-4xl`} size={20} />}
      </button>
  );
}

export default function Ticket() {
  const { state } = useLocation();
  const event  = state?.event || {};
  const service  = state?.service || {};
  const params = useParams();
  const serviceReference = params?.serviceReference;
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');
  const [quantity, setQuantity] = useState<number>(1);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [increaseDisable, setIncreaseDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const myphoneNumber=  useDataStore.getState().myPhoneNumber ;

  const initiatePayment = async (validPhoneNumber: string) => {
    setError('');
    setIsLoading(true);
    try {
      const response = await submitPayment({
        third: {
          phoneNumber: validPhoneNumber,
          firstName: "Semoa",
          lastName: "Semoa",
        },
        voucher: {
          currency: "XOF",
          amount: service?.amount,
          additionalInformation: "SEMOA-VOUCHER test",
          quantity: quantity,
        },
        service: {
          reference: serviceReference,
        },

        otherData: {
          //for the redirect url
          host: "exemple",
          env: "local",
        },
      });
      paymentStore?.getState().setPaymentData({
        paymentUrl: response?.cashPayData?.bill_url,
        voucherRequestId: response?.voucherRequestId,
      });
      navigate("/gateway", {
        state: {
          quantity: quantity,
        }
      });
      setIsLoading(false);
    } catch (e) {
      setIsModalOpen(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (myphoneNumber === null || myphoneNumber === undefined) setIsEdit(true)
  }, [myphoneNumber]);

  const increaseQuantity = () => {
    if (quantity < service?.quantity) {
      const maxService = service?.maxServiceQuantity;
      const maxEvent = event?.numberVouchersAllowedPerThird;

      const limit =
          maxService ?? (maxEvent ?? Infinity); // Prend maxService s’il existe, sinon maxEvent, sinon pas de limite

      if (quantity < limit) {
        setQuantity(quantity + 1);
      }
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const disableIncrease = () => {
    const maxService = service?.maxServiceQuantity;
    const maxEvent = event?.numberVouchersAllowedPerThird;

    if (maxService != null) {
      return quantity >= maxService;
    } else if (maxEvent != null) {
      return quantity >= maxEvent;
    } else {
      return false;
    }
  };

  useEffect(() => {
    setIncreaseDisable(disableIncrease());
  }, [quantity]);

  const handleValidPhone = (fullNumber: string) => {
    setPhoneNumber(fullNumber);
    setIsEdit(false);
  };

  const createVoucher = async (validPhoneNumber: string) => {
    setError('');
    setIsLoading(true);
    const data: createVoucherWithThirdsParams = {
      third: {
        phoneNumber: validPhoneNumber,
      },
      voucher: {
        amount: service?.amount,
        quantity,
      },
      service: {
        reference: serviceReference,
      },
    };

    try {
      const response = await createVoucherWithThirds(data);

      navigate("/billet", {
        state: {
          vouchers: response?.code ? [response] : response,
        },
      });
      setIsLoading(false);
    } catch (error) {
      // @ts-ignore
      setError(error?.response?.data?.message);
      setIsModalOpen(true);
      setIsLoading(false);
    }
  };

  const PhoneSection = () => {
    if( isEdit) {
      return (<PhoneNumberInput
          setIsPhoneValid={setIsPhoneValid}
          onValidPhone={handleValidPhone}
          required={true}
      />);
    }

    return (
        <div className='flex flex-col items-center justify-center'>
          <p>Numéro de téléphone</p>
          <p className=' font-bold text-primary text-2xl'>{phoneNumber || myphoneNumber}</p>
          <button onClick={()=> setIsEdit(true)} className='underline'>Changer de numéro de téléphone</button>
        </div>
    );
  }

  const handleSubmit = () => {
    if(myphoneNumber && !isEdit) {
      if (service?.amount === 0) {
        createVoucher(myphoneNumber);
      } else {
        initiatePayment(myphoneNumber);
      }
    }

    if(phoneNumber && isPhoneValid) {
      useDataStore.getState().setMyPhoneNumber(phoneNumber);
      if (service?.amount === 0) {
        createVoucher(phoneNumber);
      } else {
        initiatePayment(phoneNumber);
      }
    }
  }

  return (
      <div style={{
        backgroundImage: `url('/pattern-14.png')`,
        backgroundSize: 'inherit',
        backgroundPosition: 'center',
        fontFamily: "Exo",
        backgroundRepeat: 'no-repeat'
      }} className="min-h-screen flex flex-col">
        <div>
          {isModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-20 flex items-center justify-center p-4 z-50">
                <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">Echec de l'opération </h2>
                    <button
                        onClick={() => {
                          setIsModalOpen(false);
                        }}
                        className="text-gray-500 hover:text-gray-700"
                    >
                      <X size={30}/>
                    </button>
                  </div>
                  <div className="flex items-center justify-center p-4">
                    <Error/>
                  </div>
                  <p className="text-gray-600 text-center">{error || 'Une erreur est survnue  lors du traitement de votre requête.'}</p>
                  <div className="mt-4 flex justify-center flex flex-row   items-center">
                    <button
                        onClick={() => {
                          setIsModalOpen(false);
                          setError('');
                        }}
                        className="px-4 py-2 bg-gray-500 text-white rounded-full hover:bg-primary"
                    >
                      Réessayer
                    </button>
                  </div>
                </div>
              </div>
          )}
        </div>
        <div className="absolute left-4 top-4">
          <div className="rounded-full  w-12 h-12 bg-white flex items-center justify-center">
            <button onClick={() => {
              navigate(-1);
            }} className="">
              <ArrowLeft color="#000" className="w-6 h-6 "/>
            </button>
          </div>
        </div>
        <div className='h-[34vh] bg-primary bg-opacity-10 p-6 flex flex-col items-center justify-between'>
          <div className='bg-primary bg-opacity-10 size-24 flex rounded-3xl items-center justify-center'>
            <img src={'/branding/fif/ticketPlaceholder.png'} className='size-12'/>
          </div>

          <div>
            <p className="font-bold text-center text-white text-2xl">
              {service?.name}
            </p>
            <p className="text-center text-white/90 ">
              {event?.title}
            </p>
          </div>
          <p className="font-bold text-center  text-white text-4xl">
            {formatWithThousandsSeparator(service?.amount || 0)} XOF
          </p>
        </div>
        <div className="h-[65vh] w-full flex flex-col items-center justify-between p-4">
          <div className='flex-1'>
            <p className='py-4'>Selectionner la quantité</p>
            <div className='flex gap-4 items-center'>
              <QuantityButton onPress={decreaseQuantity} type='minus' disable={quantity <= 1}/>
              <p className='text-[#1B1C1D] font-bold text-3xl'>{quantity}</p>
              <QuantityButton onPress={increaseQuantity} type='plus' disable={increaseDisable}/>
            </div>
          </div>
          <div className='flex flex-1 w-full flex-col justify-end gap-4'>
            <PhoneSection/>
            <div className="p-4 bg-[#F2F9DE] w-full rounded-lg">
              <div className="flex justify-between">
                <span className="text-black"> Total </span>
                <span className="text-black font-bold">
                  {formatWithThousandsSeparator(service?.amount * quantity) || 0} XOF
                </span>
              </div>
            </div>
            <button onClick={handleSubmit}
                    className={`self-center  ${(isEdit && !isPhoneValid) ? 'bg-gray-400' : 'bg-third'} flex items-center justify-center  text-white font-semibold py-3 px-6 rounded-full w-full max-w-xs  ${isLoading ? 'cursor-not-allowed opacity-50' : ''}`}>
              {isLoading ? (
                  <div className="flex items-center">
                    <svg
                        className="animate-spin h-5 w-5 mr-3"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                      <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                      ></circle>
                      <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Traitement en cours ...
                  </div>
              ) : service?.amount === 0 ? (
                  "Obtenir ticket"
              ) : (
                  "Paiement"
              )}
            </button>
          </div>
        </div>
      </div>
  );
}
